import { ReferenceCrud } from "@/components/admin/ReferenceCrud";
import { StatusBadge } from "@/components/admin/AdminUI";

const FIELDS = [
  { name: "name", label: "Brand name", required: true, max: 120 },
  { name: "slug", label: "Slug", hint: "Leave empty to generate from the name", max: 120 },
  { name: "country", label: "Country of origin", max: 80, placeholder: "Italy" },
  { name: "logo_url", label: "Logo URL", type: "url", optional: true, nullable: true, max: 1000, placeholder: "https://…" },
  { name: "description", label: "Description", type: "textarea", rows: 4, span: 2, max: 4000 },
  { name: "seo_title", label: "SEO title", max: 70 },
  { name: "seo_description", label: "SEO description", max: 170 },
  { name: "featured", label: "Featured on Designers page", type: "switch" },
];

const COLUMNS = [
  { key: "name", label: "Brand" },
  { key: "country", label: "Country" },
  { key: "slug", label: "Slug", render: (b) => <span className="text-muted-foreground font-mono text-xs">{b.slug}</span> },
  { key: "product_count", label: "Products", className: "text-right tabular", render: (b) => b.product_count ?? 0 },
  { key: "featured", label: "Featured", render: (b) => (b.featured ? <StatusBadge status="good" label="Featured" tone="good" /> : <span className="text-muted-foreground">—</span>) },
];

export default function AdminBrands() {
  return <ReferenceCrud resource="brands" label="Brand" eyebrow="Catalog" description="Maisons and designers carried by the store. Archiving a brand hides every product it owns from the storefront." fields={FIELDS} columns={COLUMNS} writePerm="catalog.write" searchPlaceholder="Search by name, slug or country…" />;
}
